import React from "react";
import { Typography } from "@mui/material";

import LegalPage from "./LegalPage";
import LegalSection from "./LegalSection";
import {
  ACCESSIBILITY_ENFORCEMENT,
  ACCESSIBILITY_FEEDBACK_EMAIL,
  PLATFORM_NAME,
} from "./legalContentConstants";

const SECTIONS = [
  { id: "commitment", title: "1. Our commitment" },
  { id: "conformance", title: "2. Conformance status" },
  { id: "measures", title: "3. Measures we take" },
  { id: "feedback", title: "4. Feedback" },
  { id: "enforcement", title: "5. Enforcement" },
  { id: "changes", title: "6. Changes" },
];

const AccessibilityStatement = () => {
  return (
    <LegalPage
      title="Accessibility Statement"
      intro={`This statement explains how ${PLATFORM_NAME} approaches accessibility and how you can report a problem.`}
      sections={SECTIONS}
    >
      <LegalSection id="commitment" title="1. Our commitment">
        <Typography variant="body1">
          We want as many people as possible to be able to use the Service,
          regardless of ability or technology. We aim to follow recognized
          accessibility standards and continuously improve.
        </Typography>
      </LegalSection>

      <LegalSection id="conformance" title="2. Conformance status">
        <Typography variant="body1">
          TODO(legal/accessibility): state the target standard (e.g. WCAG 2.1
          Level AA / EN 301 549) and the current conformance status, including
          known limitations and any non-accessible content.
        </Typography>
      </LegalSection>

      <LegalSection id="measures" title="3. Measures we take">
        <Typography variant="body1">
          TODO(accessibility): describe the measures in place (e.g. keyboard
          navigation, colour contrast, responsive design, regular reviews).
        </Typography>
      </LegalSection>

      <LegalSection id="feedback" title="4. Feedback">
        <Typography variant="body1">
          If you encounter an accessibility barrier or need content in an
          alternative format, contact {ACCESSIBILITY_FEEDBACK_EMAIL}. We aim to
          respond within a reasonable time.
        </Typography>
      </LegalSection>

      <LegalSection id="enforcement" title="5. Enforcement">
        <Typography variant="body1">{ACCESSIBILITY_ENFORCEMENT}</Typography>
      </LegalSection>

      <LegalSection id="changes" title="6. Changes">
        <Typography variant="body1">
          This statement is reviewed periodically and updated as the Service
          changes.
        </Typography>
      </LegalSection>
    </LegalPage>
  );
};

export default AccessibilityStatement;
